module.exports = __webpack_public_path__ + "img/7.58a23e70.jpg";